import {
  countPendingAndFailed,
  listJobsBySync,
  type LocalJob,
} from '../db/jobsDb.js';

/** Warn when any pending/syncing entry is older than this (ms). */
export const UNSYNCED_WARN_MS = 4 * 60 * 60 * 1000; // 4 hours

export function exportPendingText(jobs: LocalJob[]): string {
  const lines = [
    'Terratech Agent — pending / failed local jobs',
    `Exported: ${new Date().toISOString()}`,
    '',
  ];
  for (const j of jobs) {
    lines.push(
      [
        j.work_date,
        j.duration_type,
        `client=${j.client_id}`,
        `type=${j.work_type_id}`,
        j.site_ids?.length ? `site_ids=${j.site_ids.join(',')}` : null,
        j.site_reference ? `site_ref=${j.site_reference}` : null,
        `billable=${j.billable !== false}`,
        j.status ? `status=${j.status}` : null,
        j.po_number ? `po=${j.po_number}` : null,
        j.custom_hours != null ? `hours=${j.custom_hours}` : null,
        j.custom_amount != null ? `amount=${j.custom_amount}` : null,
        `state=${j.syncState}`,
        j.failReason ? `fail=${j.failReason}` : null,
        `id=${j.id}`,
        `created=${j.createdAt}`,
      ]
        .filter(Boolean)
        .join(' | '),
    );
  }
  if (jobs.length === 0) lines.push('(none)');
  return lines.join('\n');
}

/** @deprecated chrome moved to header/settings — kept for any leftover imports */
export async function mountStatus(
  _root: HTMLElement,
  _hooks: { onSignedIn: () => void; onRetrySync: () => void },
): Promise<{
  refresh: () => Promise<void>;
  setNeedsSignIn: (v: boolean) => void;
}> {
  return {
    refresh: async () => {
      void (await countPendingAndFailed());
      void (await listJobsBySync('pending'));
    },
    setNeedsSignIn() {},
  };
}
